import { useEffect } from "react";
import { feedbackMap, generateGUID } from "../utils/utils";
import { GPTResponse, type } from "@/utils/types";
import ResizeFeedback from "./ResizeFeedback";
import { useAppContext } from "@/appContext";
import { FeedbackType } from "@/utils/types";
import Nav from "./nav";
import { updateFeedbackAccessibility } from "@/api";


function PastFeedback({adminView}:{adminView?:boolean}) {
  const { reducers, state, startFunc, navigateThenRun, setQs } = useAppContext();
  const { setfeedbackcontext } = reducers;

  const nextClick =() => {
    startFunc(state.currentQuestion + 1, false)
  }

  const retryClick=() => {
    startFunc(state.currentQuestion, true);
  }

  const retryPast= () => {
    navigateThenRun(() => {
      reducers.setrole(state.session[0].role);
      reducers.updatesession({ sessionId: generateGUID(), type: type.CUSTOM });
      reducers.settype(state.session[state.currentQuestion].question.type);
      setQs(null, state.session[state.currentQuestion].question);
      reducers.setqType("choose question");
      reducers.setcurrentQuestion(0);
      reducers.setretryPast(true);
    }, "/interview");
  }

  const updateAccessibleToOrg = async (e: boolean): Promise<void> => {
    const access = state.pastInfo["orgAccessible"];
    if (access === undefined || access !== e) {
      const user2 = await updateFeedbackAccessibility(
        e,
        state.session[state.currentQuestion].question.question,
        state.pastInfo["index"]
      );
      reducers.setprofileUser(user2);
      reducers.setpastInfo({ ...state.pastInfo, orgAccessible: e });
    }
  };
  
  // Useful function
  useEffect(() => {
    const fetchFeedback = async () => {
      const feed = await feedbackMap(
        state.showAns
          ? state.session[state.currentQuestion].samplesolution
          : state.showAction
          ? state.session[state.currentQuestion].actionsteps
          : state.session[state.currentQuestion].feedback
      );
      if (!feed) {
        //setfeedbackcontext([]);
        return;
      };

      const finalFeedback: FeedbackType = [];
      for (let i = 0; i < feed[0].length; i++) {
        finalFeedback.push({
          title: feed[0][i],
          badgeType: feed[1][i] as any,
          desc: feed[2][i],
        });
      }

      setfeedbackcontext(finalFeedback);
    };

    if (!state.showFeedback) return;
    fetchFeedback();
  }, [
    state.session[state.currentQuestion].samplesolution,
    state.showAction,
    state.session[state.currentQuestion].actionsteps,
    state.session[state.currentQuestion].feedback,
    state.showFeedback,
    state.promptArray,
  ]);

  return (
    <>
    {!adminView && <Nav />}
    <div className="overflow-hidden bg-white">
      <ResizeFeedback
        displayPastFeedback={state.displayPastFeedback}
        retryClick={!adminView ? retryPast: undefined}
        nextClick={!adminView && state.currentQuestion < state.session.length -1 ? nextClick : undefined}
        org={!adminView ?{
          inOrg: state.profileUser &&
          state.profileUser.organization !== undefined &&
          state.profileUser.organization !== ""
            ? true
            : false,
          accessibleToOrg: state.pastInfo["orgAccessible"],
          updateAccessibleToOrg: updateAccessibleToOrg,
        }:undefined}
        adminView={adminView}
      />
    </div>
    </>
  );
}

export default  PastFeedback;
